import { CookiesService } from '../cookies/cookies.service';
import { AnalyticsConsent, AnalyticsConsentOption } from './types';

const ANALYTICS_CONSENT_COOKIE = 'noblewillsAnalyticsConsent';
export const ANALYTICS_CONSENT_CHANGED = 'noblewills:analytics-consent-changed';
const ONE_YEAR_IN_DAYS = 365;

export class AnalyticsConsentService {
    static getConsent(): AnalyticsConsent {
        if (typeof window === 'undefined') return undefined;
        const consent = new CookiesService().get<AnalyticsConsent>(ANALYTICS_CONSENT_COOKIE);
        return consent === 'accepted' || consent === 'rejected' ? consent : undefined;
    }

    static setConsent(consent: AnalyticsConsentOption): void {
        const expires = new Date();
        expires.setDate(expires.getDate() + ONE_YEAR_IN_DAYS);
        new CookiesService().set(ANALYTICS_CONSENT_COOKIE, consent, { expires });
        window.dispatchEvent(new Event(ANALYTICS_CONSENT_CHANGED));
    }
}
